export const singleProductInit = () => {
  if(document.querySelector('.full-desc-link')) {
    const scrollBtn = document.querySelector('.full-desc-link');
    const prodDesc = document.querySelector('.single-product__description');

    if(prodDesc) {
      scrollBtn.addEventListener('click', (e) => {
        prodDesc.scrollIntoView({
          behavior: 'smooth'
        });
      });
    }
  }
}